import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import { LotStatus } from "@/enums/LotStatus";

  interface Props {
    isOpen: boolean;
    lotTitle: string;
    currentStatus?: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CancelHoldModal',
  props: {
    isOpen: { type: Boolean },
    lotTitle: {},
    currentStatus: { default: LotStatus.HOLD }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const statusText = computed(() => {
    if (props.currentStatus === LotStatus.UNDER_CONTRACT)
      return "Under Contract";

    if (props.currentStatus === LotStatus.UNCONDITIONAL) return "Unconditional";

    return "Hold";
  });

  const modalTitle = computed(() => {
    return `Cancel ${statusText.value} on ${props.lotTitle}?`;
  });

  const modalDescription = computed(() => {
    return `This will reset the lot back to Available and clear the buyer name(s).`;
  });

  const close = () => {
    emit("close");
  };

  const confirm = () => {
    emit("confirm");
    close();
  };

const __returned__ = { props, emit, statusText, modalTitle, modalDescription, close, confirm, computed, Modal, get LotStatus() { return LotStatus } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})